import apiClient from "./client";
import type {
  RestaurantExtra,
  CreateRestaurantExtraRequest,
  UpdateRestaurantExtraRequest,
} from "@/types";

interface ListRestaurantExtrasResponse {
  extras: RestaurantExtra[];
}

export const restaurantExtrasApi = {
  getExtras: async (): Promise<RestaurantExtra[]> => {
    const response = await apiClient.get<ListRestaurantExtrasResponse>(
      "/restaurant-extra/forRestaurant"
    );
    return response.data.extras;
  },

  createExtra: async (
    data: CreateRestaurantExtraRequest
  ): Promise<RestaurantExtra> => {
    const response = await apiClient.post<RestaurantExtra>(
      "/restaurant-extra",
      data
    );
    return response.data;
  },

  updateExtra: async (
    id: number,
    data: UpdateRestaurantExtraRequest
  ): Promise<RestaurantExtra> => {
    const response = await apiClient.patch<RestaurantExtra>(
      `/restaurant-extra/${id}`,
      data
    );
    return response.data;
  },

  deleteExtra: async (id: number): Promise<void> => {
    await apiClient.delete(`/restaurant-extra/${id}`);
  },
};
